/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KopiaRobocza } from '../../models/kopia-robocza';

export interface ApiWebInstytucjeNipRoboczeKrbIdGet$Params {

/**
 * Identyfikator kopii.
 */
  krbId: number;
  nip: string;
}

export function apiWebInstytucjeNipRoboczeKrbIdGet(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipRoboczeKrbIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<KopiaRobocza>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipRoboczeKrbIdGet.PATH, 'get');
  if (params) {
    rb.path('krbId', params.krbId, {});
    rb.path('nip', params.nip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KopiaRobocza>;
    })
  );
}

apiWebInstytucjeNipRoboczeKrbIdGet.PATH = '/api/web/instytucje/{nip}/robocze/{krbId}';
